import "./Contact.module.css";
import CommandCenterHeader from "@/reusable_sections/Header";
import EstablishCommunications from "./sections/EstablishCommunications";
import VacavilleHq from "./sections/VacavilleHq";
import BaseOperationsFooter from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <CommandCenterHeader />
      <EstablishCommunications />
      <VacavilleHq />
      <BaseOperationsFooter />
    </div>;
}